import { AnySchema, object, ObjectSchema } from 'yup';

export const getSchema = <T extends Record<string, AnySchema>>(obj: T): ObjectSchema<Record<keyof T, AnySchema>> => {
	return object().shape(obj);
};
